<template>
  <div class="select-roles">
    <div :class="{checked : rol === 'admin'}">
      <input type="radio" :id="est.id + 'admin'" value="admin" class="we-radio" :name="'est' + est.id" v-model="rol">
      <label :for="est.id + 'admin'"></label>
    </div>
    <div :class="{checked : rol === 'write'}">
      <input type="radio" :id="est.id + 'write'" value="write" class="we-radio" :name="'est' + est.id" v-model="rol">
      <label :for="est.id + 'write'"></label>
    </div>
    <div>
      <input type="radio" :id="est.id + 'read'" value="read" class="we-radio" :name="'est' + est.id" v-model="rol">
      <label :for="est.id + 'read'"></label>
    </div>
  </div>
</template>

<script>
export default {
  name: 'user-roles',
  props: {
    est: {
      type: Object,
      required: true
    },
    userId: {
      type: String,
      required: false,
      default: ''
    }
  },
  data () {
    return {
      rol: 'read'
    }
  },
  beforeMount () {
    this.$forceUpdate()
    this.$emit('updated-rol', this.est.id, this.rol)
  },
  watch: {
    rol () {
      this.$emit('updated-rol', this.est.id, this.rol)
    },
    userId () {
      if (this.userId) {
        this.rol = this.est.users.find(e => e.id == this.userId).establishmentRole
      } else {
        this.rol = 'read'
      }
    }
  }
}
</script>
